/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MatchCreator
 */
export interface MatchCreator {
    /**
     * 
     * @type {string}
     * @memberof MatchCreator
     */
    matchId: string;
    /**
     * Recorded creator email; null when unavailable.
     * @type {string}
     * @memberof MatchCreator
     */
    createdBy?: string | null;
}

/**
 * Check if a given object implements the MatchCreator interface.
 */
export function instanceOfMatchCreator(value: object): value is MatchCreator {
    if (!('matchId' in value) || value['matchId'] === undefined) return false;
    return true;
}

export function MatchCreatorFromJSON(json: any): MatchCreator {
    return MatchCreatorFromJSONTyped(json, false);
}

export function MatchCreatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchCreator {
    if (json == null) {
        return json;
    }
    return {
        
        'matchId': json['matchId'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
    };
}

export function MatchCreatorToJSON(json: any): MatchCreator {
    return MatchCreatorToJSONTyped(json, false);
}

export function MatchCreatorToJSONTyped(value?: MatchCreator | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'matchId': value['matchId'],
        'createdBy': value['createdBy'],
    };
}

